import isPlainObject from 'lodash-es/isPlainObject';
import flattenWhenNode from './flattenWhenNode';

export default flattenWhenNode(isPlainObject);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/flattenActionMap.js
// module id = 1349
// module chunks = 7